module.exports = {
	"textures": [
		{
			"image": "StatisticsAtlas",
			"format": "RGBA8888",
			"size": {
				"w": 561,
				"h": 1122
			},
			"scale": 1,
			"frames": [
				{
					"filename": "00_StatisticsWheel.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 557,
						"h": 557
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 557,
						"h": 557
					},
					"frame": {
						"x": 2,
						"y": 2,
						"w": 557,
						"h": 557
					}
				},
				{
					"filename": "StatisticsWheel.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 557,
						"h": 557
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 557,
						"h": 557
					},
					"frame": {
						"x": 2,
						"y": 563,
						"w": 557,
						"h": 557
					}
				}
			]
		}
	],
	"meta": {
		"app": "http://free-tex-packer.com",
		"version": "0.6.7"
	}
};